import React from 'react';
import { motion } from 'framer-motion';
import { manifesto } from '../mock';

const Manifesto = () => {
  return (
    <section id="manifesto" className="py-24 relative overflow-hidden bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Title Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-xs font-bold tracking-widest uppercase text-purple-600 mb-3"
          >
            Our Core Principles
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-5xl font-extrabold font-display text-slate-900 tracking-tight"
          >
            The Digital Manifesto
          </motion.p>
        </div>

        {/* 4 Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {manifesto.map((item, index) => (
            <motion.div
              key={item.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              whileHover={{ y: -6 }}
              className="p-8 rounded-3xl glass-card relative group overflow-hidden"
            >
              {/* Corner Number */}
              <span className="absolute top-6 right-8 text-5xl font-extrabold font-display text-purple-600/10 group-hover:text-purple-600/25 transition-colors">
                {item.number}
              </span>

              {/* Title & Content */}
              <h3 className="text-2xl font-bold font-display text-slate-900 mb-4 group-hover:text-purple-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed font-normal">
                {item.description}
              </p>

              {/* Hover Accent Line */}
              <div className="w-12 h-1 bg-gradient-to-r from-purple-600 to-pink-500 rounded-full mt-6 group-hover:w-24 transition-all duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
